export enum SensorTypeEnum {
    None = 0,
    MINIMA = 1,
    MAXIMA = 2,
    EXT = 3,
    API = 4,
}